import { type UIFlagEnvironmentFilter, flagEnvironmentFilters } from './flagEnvironmentFilters';

export function isEnvironmentFilter(value: string): value is keyof UIFlagEnvironmentFilter {
  return flagEnvironmentFilters.some((filter) => filter === value);
}
